module.exports = {"archivedTransactions":"Archived transactions","customerCreated":"Customer Created: ","boxOffice":"Box Office"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchResults/SearchResultsCustomer/locales/en.json
// module id = 1425
// module chunks = 0